export const ContactPage: React.FC<{}> = () => {
  return (
    <div id="div-application-contact" className="div application-contact">
      <section className="block block-tight">
        <div className="wrap">
          <div className="eyebrow">Contact</div>
          <h3 className="section-head">Talk to us directly.</h3>
          <p className="lede">
            No contact forms and no ticket system — just email, read by the
            people who build the product.
          </p>

          <div className="contact-grid">
            <div className="panel contact-card">
              <h4>Sales &amp; general inquiries</h4>
              <p>
                New projects, partnership questions, or anything about SML
                Engineering.
              </p>
              <a className="mail" href="mailto:sales@steamtownmedia.com">
                sales@steamtownmedia.com
              </a>
            </div>
            <div className="panel contact-card">
              <h4>Support</h4>
              <p>
                Help with Pic Perfect 3, DayFocus, or an existing SML
                Engineering deployment.
              </p>
              <a className="mail" href="mailto:support@steamtownmedia.com">
                support@steamtownmedia.com
              </a>
            </div>
          </div>

          <p className="contact-location mono">
            Steamtown Media Limited &middot; Gilbertsville, Pennsylvania, USA
          </p>
        </div>
      </section>
    </div>
  );
};
